<template>
  <div>
    <click-to-edit
      v-model="scope.row.scale.expectation_partial"
      :disabled="!isFieldAvailableForEdit(scope.row, 'scale.expectation_partial')"
      placeholder=""
      type="textarea"
      style="width: 100%"
      @input="saveElementPropChange(scope.row, 'scale', {expectation_partial:$event})"
    ></click-to-edit>
  </div>
</template>

<script>

import ClickToEdit from "@/components/ClickToEdit";
import {ElementPropTableColumn} from "@/mixins/elementPropTableColumn";
import {variables} from "@/componentsCompany/smz/variables";
export default {
  name: 'element-expectation-partial-table-column',
  components: {ClickToEdit},
  mixins: [ElementPropTableColumn],

  props: {},
  data() {
    return {
      scaleTypesEnum: variables.scaleTypesEnum,
    }
  },
  computed: {},
  methods: {

  }
}

</script>

<style scoped lang="scss">
@import "@/assets/css/project-variables";

</style>
